import React, { useState } from "react";
import "../Style/Navbar.css"; // Import the CSS for styles
import logo from '../Images/brandlogo.png'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // State to toggle the navbar

  const toggleNavbar = () => {
    setIsOpen(!isOpen); // Toggle the navbar visibility
  };

  const gotohomepage= () => {
    window.location.href = '/AboutSection'
   }

  return (
    <header>
        <img 
        src={ logo }
        alt="Preschool Logo" 
        className="logo" 
        onClick={gotohomepage}
        style={{ cursor: 'pointer',  objectFit:'cover'}}
      />
      <nav className="hamburger-div">
        {/* Hamburger icon for mobile */}
        <div className="hamburger" onClick={toggleNavbar}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
        <ul className={`navbar-links ${isOpen ? "open" : ""}`}>
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
        
        
      </nav>
    </header>
  );
};

export default Navbar;
